@if (withIcon()) {
  <i class="icon icon-check"></i>
}
<span><ng-content/></span>
